import Big from 'big.js'
export default {
  Big,
  formatAddr(Obj) {
    return (Obj.provinceName || '') + (Obj.cityName || '') + (Obj.areaName || '') + (Obj.addressDetail || '')
  },
  rules: {
    mobileOrPhone: {
      pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
      msg: '请输入手机号码或座机'
    }
  }
}
